import { useRef, useEffect, useState } from 'react';

const useRefSize = () => {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const handleResize = () => {
    try {
      if (ref && ref.current) {
        const width = ref.current?.offsetWidth || 0;
        const height = ref.current?.offsetHeight || 0;
        if (width > 0 || height > 0) {
          setSize({ width, height });
        }
      }
    } catch (error) {
      console.warn('Error getting ref size:', error);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const refreshSize = () => handleResize();
  return { ref, width: size.width, height: size.height, refreshSize };
};

export default useRefSize;
